"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const stats = [{
  number: "€1M+",
  label: "VALORE MINIMO PROGETTO"
}, {
  number: "15",
  label: "ANNI DI DOMINIO"
}, {
  number: "\xA0EST/OVEST",
  label: "CORRIDOI SBLOCCATI"
}];
function StatItem({
  stat,
  index
}: {
  stat: {
    number: string;
    label: string;
  };
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <div ref={ref} data-index={index} className={`relative flex flex-col items-center justify-center py-12 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
    transitionDelay: `${index * 200}ms`
  }}>
      {}
      <div className="absolute inset-0 flex items-center justify-center text-[100px] md:text-[160px] lg:text-[200px] font-serif text-secondary/10 select-none pointer-events-none whitespace-nowrap" aria-hidden="true">
        {stat.number}
      </div>

      {}
      <div className="relative z-10 flex flex-col items-center text-center">
        <div className="font-serif text-secondary leading-none tracking-tighter !text-[120px]">
          {stat.number}
        </div>
        <div className="mt-6 font-sans text-lg md:text-xl text-foreground uppercase tracking-[0.2em] font-bold">
          {stat.label}
        </div>
      </div>
    </div>;
}
export default function MetricheDiImpatto() {
  return <section id="metriche-di-impatto" className="dark bg-background text-foreground py-32 md:py-48 overflow-hidden relative">
      <div className="max-w-7xl mx-auto px-6 md:px-8 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-24 md:gap-8">
          {stats.map((stat, i) => <StatItem key={i} stat={stat} index={i} />)}
        </div>
      </div>
    </section>;
}